"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.removeReminder = exports.setReminder = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var types = _interopRequireWildcard(require("../store/actions/actionTypes"));

var _UpdateNotificationsService = _interopRequireDefault(require("../service/UpdateNotificationsService"));

var _PulseApiHelper = _interopRequireDefault(require("../service/PulseApiHelper"));

var _metrics = _interopRequireDefault(require("@adobe/exc-app/metrics"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var instance;

var metrics = function metrics() {
  return instance || (instance = _metrics.default.create('exc.pulse.actions.Reminders'));
};
/**
 * This method will set the reminder
 * and remove it if the API fails.
 *
 * @param notification
 * @param serverTime
 * @param reminderInMillsecs
 */


var setReminder = function setReminder(notification, serverTime, reminderInMillsecs) {
  return (
    /*#__PURE__*/
    function () {
      var _ref = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee(dispatch) {
        var queryObject, _ref2, notifications;

        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                dispatch({
                  type: types.SET_REMINDER_ON_NOTIFICATION,
                  payload: {
                    id: notification.id,
                    reminderTime: serverTime + reminderInMillsecs
                  }
                });
                queryObject = _PulseApiHelper.default.createANSFormatForReminders(_objectSpread({}, notification, {
                  reminderTime: serverTime + reminderInMillsecs
                }));
                _context.next = 4;
                return _UpdateNotificationsService.default.updateNotifications([queryObject]);

              case 4:
                _ref2 = _context.sent;
                notifications = _ref2.notification;

                if (notifications.length !== 1) {
                  dispatch({
                    type: types.REMOVE_REMINDER_ON_NOTIFICATION,
                    payload: {
                      id: notification.id
                    }
                  });
                } else {
                  metrics().event('reminder.set.success', {
                    region: window.config && window.config.region
                  });
                }

                return _context.abrupt("return", notifications.length === 1);

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }()
  );
};
/**
 * This API will remove/delete the reminder.
 *
 * @param notification
 */


exports.setReminder = setReminder;

var removeReminder = function removeReminder(notification) {
  return (
    /*#__PURE__*/
    function () {
      var _ref3 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee2(dispatch) {
        var queryObject, _ref4, notifications;

        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return dispatch({
                  type: types.REMOVE_REMINDER_ON_NOTIFICATION,
                  payload: {
                    id: notification.id
                  }
                });

              case 2:
                queryObject = _PulseApiHelper.default.createANSFormatForClearReminders(notification);
                _context2.next = 5;
                return _UpdateNotificationsService.default.updateNotifications([queryObject]);

              case 5:
                _ref4 = _context2.sent;
                notifications = _ref4.notification;

                if (notifications.length !== 1) {
                  /**
                   * TODO: Error handling needs to be done for this
                   */
                } else {
                  metrics().event('reminder.removed', {
                    region: window.config && window.config.region
                  });
                }

                return _context2.abrupt("return", notifications.length === 1);

              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x2) {
        return _ref3.apply(this, arguments);
      };
    }()
  );
};

exports.removeReminder = removeReminder;
var _default = {
  setReminder: setReminder,
  removeReminder: removeReminder
};
exports.default = _default;